import { UsersApi } from '../../../Apis'


export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';





export function setUserDataTracknMe(sessionTracknme) {
    return async (dispatch) => {
        
        let settings = {};
        if (sessionTracknme.user.profile === 'USER') {
            settings = {
                layout: {
                    style : 'layout1',
                    config: {
                        navbar        : {
                            display: false
                        },
                    }
                }
            }
        }

       

        const responseMetadata = await UsersApi.getMetadataById(sessionTracknme.user.id);
        
        const user = {
            uid: sessionTracknme.user.id,
            role: [sessionTracknme.user.profile],
            from: 'tracknme',
            brand: sessionTracknme.user.brand,
            data: {
                displayName: sessionTracknme.user.name,
                email: sessionTracknme.user.login,
                settings,
                shortcuts: [
                    'trackback-component',
                    'notifications-component',
                    'groups-component',
                    'security-area-component',
                    'my-account-component',
                    'phonebook-component',
                    'reports-component',
                    'user-preferences-component'
                ],
            },
            metadata: {
                ...responseMetadata.data
            }

        }

       
     
        if( sessionTracknme.user.profile === 'USER'){
           // dispatch(Actions.setCurrentUserData(sessionTracknme.user))
        }
        
        return dispatch(setUserData(user));
    }
}

/**
 * Set User Data
 */
export function setUserData(user)
{
    return (dispatch) => {

        /*
        Set User Settings
         */
      
        /*
        Set User Data
         */
        dispatch({
            type   : SET_USER_DATA,
            payload: user
        })
    }
}



/**
 * Update User Metada
 */
export function updateUserMetadata(metadata)
{
    return async (dispatch, getState) => {

        await UsersApi.updateMetadata(metadata);

        const user = getState().auth.user;

        if (user.uid === metadata.id) {
            const newUser = {
                ...user,
                data: {
                    ...user.data,
                    settings: null
                },
                metadata
            };
    
            
            
            return dispatch(setUserData(newUser))
        } 
        
    }
}



/**
 * Remove User Data
 */
export function removeUserData()
{
    return {
        type: REMOVE_USER_DATA
    }
}